module.exports = __webpack_public_path__ + "img/aburgermenu.be078865.svg";